import React from 'react';
import { createRoot } from 'react-dom/client';
import EnApp from './EnApp';
import PrivacyPage from './PrivacyPage';
import './en.css';

const isPrivacyPolicy = window.location.pathname.startsWith('/privacy-policy');

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isPrivacyPolicy ? <PrivacyPage /> : <EnApp />}
  </React.StrictMode>
);